import { Link } from "react-router-dom";
import arts from "../../assets/images/activity/theater.png";
import physical from "../../assets/images/activity/running.png";
import lifeskills from "../../assets/images/activity/social-life.png";
import newspaper from "../../assets/images/activity/newspaper.png";

const CoScholatic = () => {
  return (
    <section className="tutor-two py-60 position-relative z-1 half-bg half-bg__64 style-two">
      <div className="container">
        <div className="section-heading text-center">
          <div
            className="flex-align d-inline-flex gap-8 mb-16"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            <h5 className="text-main-600 mb-0">Co-Scholastic Programs</h5>
          </div>
          <h2
            className="mb-24"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="100"
          >
            Unlocking Potential Beyond Academics
          </h2>
        </div>

        <div className="row gy-4">
          {/* Arts */}
          <div
            className="col-xxl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-delay="0"
          >
            <div className="bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center">
              <div className="bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2">
                <Link to="/co-scholastic-program" aria-label="Explore Arts">
                  <div className="w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative">
                    <span className="border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center">
                      <img
                        src={arts}
                        alt="Arts education"
                        loading="lazy"
                        style={{ height: 60 }}
                      />
                    </span>
                  </div>
                </Link>
                <h4 className="display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2">
                  Arts
                </h4>
                <p className="text-sm text-neutral-500 item-hover__text transition-2 mt-16">
                  Education
                </p>
              </div>
            </div>
          </div>

          {/* Physical */}
          <div
            className="col-xxl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center">
              <div className="bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2">
                <Link
                  to="/co-scholastic-program"
                  aria-label="Explore Physical Education"
                >
                  <div className="w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative">
                    <span className="border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center">
                      <img
                        src={physical}
                        alt="Physical education"
                        loading="lazy"
                        style={{ height: 60 }}
                      />
                    </span>
                  </div>
                </Link>
                <h4 className="display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2">
                  Physical
                </h4>
                <p className="text-sm text-neutral-500 item-hover__text transition-2 mt-16">
                  Education
                </p>
              </div>
            </div>
          </div>

          {/* Life Skills */}
          <div
            className="col-xxl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center">
              <div className="bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2">
                <Link
                  to="/co-scholastic-program"
                  aria-label="Explore Life Skills"
                >
                  <div className="w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative">
                    <span className="border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center">
                      <img
                        src={lifeskills}
                        alt="Life skills education"
                        loading="lazy"
                        style={{ height: 60 }}
                      />
                    </span>
                  </div>
                </Link>
                <h4 className="display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2">
                  Life Skills
                </h4>
                <p className="text-sm text-neutral-500 item-hover__text transition-2 mt-16">
                  Education
                </p>
              </div>
            </div>
          </div>

          {/* Newspaper in Education */}
          <div
            className="col-xxl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center">
              <div className="bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2">
                <Link
                  to="/co-scholastic-program"
                  aria-label="Explore Newspaper in Education"
                >
                  <div className="w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative">
                    <span className="border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center">
                      <img
                        src={newspaper}
                        alt="Newspaper in Education (NIE)"
                        loading="lazy"
                        style={{ height: 60 }}
                      />
                    </span>
                  </div>
                </Link>
                <h4 className="display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2">
                  Newspaper
                </h4>
                <p className="text-sm text-neutral-500 item-hover__text transition-2 mt-16">
                  in Education (NIE)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoScholatic;
